import { Injectable } from '@angular/core';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { createFrom, EventService } from '@spartacus/core';
import { NavigationEvent } from '@spartacus/storefront';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { GtmGgCartPageEvent } from './gtm-gg-cart-page-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgCartPageEventBuilder {
  constructor(
    private eventService: EventService,
    private activeCartService: ActiveCartFacade
  ) {
    const gtmGgCartPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'cart'),
      switchMap(() =>
        this.activeCartService.getActive().pipe(
          filter((activeCart) => Boolean(activeCart.entries)),
          take(1),
          map((activeCart) =>
            createFrom(GtmGgCartPageEvent, {
              event: 'checkout-step',
              ecommerce: {
                checkout: {
                  actionField: {
                    step: 1,
                  },
                  products: this.getProductsFromActiveCart(activeCart),
                },
              },
            })
          )
        )
      )
    );

    eventService.register(GtmGgCartPageEvent, gtmGgCartPageEventSource);
  }

  getProductsFromActiveCart(activeCart: Cart) {
    const products: {
      name?: string;
      price?: string;
      id?: string;
      variant?: string;
      brand?: string;
      quantity?: number;
    }[] = [];

    activeCart.entries?.forEach((entry) => {
      const product = {
        name: entry.product?.name ? entry.product?.name : '',
        price: entry.basePrice?.value ? entry.basePrice?.value.toString() : '',
        id: entry.product?.code ? entry.product?.code : '',
        variant: entry.product?.variantType ? entry.product?.variantType : '',
        brand: entry.product?.manufacturer ? entry.product?.manufacturer : '',
        quantity: entry.quantity,
      };

      products.push(product);
    });

    return products;
  }
}
